/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_StatusInputs */

const en_reports_col_status = /** @type {(inputs: Reports_Col_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case status`)
};

const pt_br2_reports_col_status = /** @type {(inputs: Reports_Col_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status caso`)
};

/**
* | output |
* | --- |
* | "Case status" |
*
* @param {Reports_Col_StatusInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_col_status = /** @type {((inputs?: Reports_Col_StatusInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_StatusInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_status(inputs)
	return pt_br2_reports_col_status(inputs)
});